// extracted by mini-css-extract-plugin
export default {"popupContent":"HeadphonesSuggestedInfoPopup_popupContent__gYg7Y"};